import styled from "styled-components";

import { Modal } from "components/Modal";

export const SnaptradeModalContainer = styled(Modal)`
  .modal-content {
    padding-bottom: 0;

    .modal-body {
      margin-top: -40px;
      height: 650px;

      figure {
        height: 100%;

        .dark {
          color-scheme: dark;
        }

        .light {
          color-scheme: light;
        }

        iframe {
          width: 100%;
          height: 100%;
          inset: 0px;
          z-index: 1000;
          border-width: 0px;
          display: block;
          overflow: auto;
        }
      }
    }
  }
`;

export const AcknowledgementViewContainer = styled(Modal)`
  .modal-content {
    padding-bottom: 0;

    .modal-body {
      margin-top: -20px;
      padding: 0 2rem 2rem 2rem;

      .heading {
        padding: 0 16px;
        text-align: center;
        font-weight: 300;
        font-size: 24px;

        b {
          font-weight: bold;
        }
      }

      .content-wrapper {
        margin-top: 50px;

        .details {
          display: grid;
          grid-template-columns: 0.12fr 1fr;
          margin-bottom: 30px;

          svg {
            width: 22px;
            margin-right: 20px;
            align-self: center;
          }

          h3 {
            font-size: 18px;
            margin: 0px 0px 5px 5px;
            line-height: 30px;
          }

          p {
            font-size: 14px;
            margin: 0px 0px 0px 5px;
          }
        }
      }

      .terms-conditions {
        text-align: center;
        font-size: 12px;
        margin-top: 50px;

        a {
          text-decoration: underline;
        }
      }

      .btn-continue {
        margin-top: 16px;
        width: 100%;
      }
    }

    @media (max-width: 768px) {
      .modal-body {
        padding: 0 1rem 1.5rem 1rem;

        .heading {
          font-size: 20px;
        }

        .content-wrapper {
          margin-top: 40px;

          .details {
            grid-template-columns: 0.16fr 1fr;
            margin-bottom: 20px;
          }
        }

        .terms-conditions {
          margin-top: 40px;
        }
      }
    }
  }
`;

export const BrokerListViewContainer = styled(Modal)`
  .modal-content {
    padding-bottom: 0;

    .modal-body {
      padding: 0 1rem 2rem 1rem;
      min-height: 650px;
      max-height: 650px;

      .heading {
        font-weight: 300;
        font-size: 24px;
      }

      .content-wrapper {
        margin-top: 20px;
      }

      .link-more {
        cursor: pointer;
        text-align: center;
        text-decoration: underline;
        margin-top: 10px;
      }
    }

    @media (max-width: 768px) {
      .modal-body {
        padding: 0 1rem 1.5rem 1rem;

        .heading {
          font-size: 20px;
        }
      }
    }
  }
`;

export const HeaderLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  .img-wrapper {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    border: 1px solid #202c40;
    background-color: ${({ theme }) => theme.modal.bg.primary};

    img {
      width: 100%;
      object-fit: cover;
    }

    &:not(:first-child) {
      margin-inline-start: -8px;
      padding: 12px;
    }
  }
`;

export const ConfirmBrokerSelectionContainer = styled(Modal)`
  .modal-content {
    padding-bottom: 0;

    .modal-body {
      padding: 0 2rem 2rem 2rem;

      .icon-back {
        cursor: pointer;
        margin-left: -26px;
      }

      .icon-broker {
        height: 38px;
        width: 38px;
      }

      .heading {
        margin-top: 20px;
        font-weight: 600;
        font-size: 25px;
      }

      .content-wrapper {
        margin-top: 20px;

        ul {
          list-style: disc;
          margin-block-end: 16px;
          margin-block-start: 16px;

          li {
            padding-bottom: 20px;
          }
        }
      }

      .btn-continue {
        display: flex;
        justify-content: center;
        margin-top: 16px;
        width: 100%;

        .on-btn {
          margin-right: 10px;
        }
      }
    }

    @media (max-width: 768px) {
      .modal-body {
        padding: 0 1rem 1.5rem 1rem;

        .heading {
          font-size: 20px;
        }
      }
    }
  }
`;
// new models style
export const IntroductionContainer = styled(Modal)`
  .modal-dialog {
    max-width: 657px;
  }

  .modal-content {
    padding: 0;
    border: none;
    border-radius: 16px;

    .modal-body {
      padding: 1.5rem;
      margin: 0;

      .multipal-icons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 108px;
      }

      h2 {
        font-size: 24px;
        font-family: "Geist", sans-serif;
        font-weight: 500;
        text-align: center;
        background: linear-gradient(
          63deg,
          var(--colors-gray-light-mode-800, #252b37) 16.72%,
          var(--colors-gray-light-mode-600, #535862) 83.39%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 12px;
      }

      p {
        font-size: 16px;
        font-family: "Geist", sans-serif;
        text-align: center;
        color: rgba(10, 13, 18, 0.6);
        line-height: 1.5;
        margin-bottom: 32px;
        padding: 0px 20px;
      }

      .next-button {
        width: 200px;
        margin: 0px auto 76px;
      }
    }
  }
`;

export const SurmountCardWrapper = styled.div`
  margin: 12px 0;
`;

export const BrokerSelectionContainer = styled(Modal)`
  .modal-dialog {
    max-width: 657px;
  }

  .modal-content {
    padding: 0;

    .modal-body {
      padding: 1.5rem;
      margin: 0;

      /* Top Icon Wrapper */
      .top-imag {
        width: 48px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #d5d7da;
        border-radius: 10px;
        margin-bottom: 16px;

        img {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }
      }

      .heading {
        font-size: 16px;
        font-family: "Geist", sans-serif;
        font-weight: 500;
        color: #181d27;
        margin-bottom: 0;
      }

      .loader-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 130px auto;
      }

      .broker-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        max-height: 478px;
        overflow-y: auto;
        padding-top: 20px;

        .broker-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          padding: 1rem;
          border: 1px solid #e9eaeb;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s;

          &:hover {
            border-color: #2258f1;
            background: ${({ theme }) => theme.card.bg.hover};
          }

          &.selected {
            border-color: #2258f1;
            background: ${({ theme }) => theme.card.bg.hover};
          }

          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }

          span {
            font-size: 12px;
            font-family: "Geist", sans-serif;
            font-weight: 500;
            text-align: center;
            color: rgba(10, 13, 18, 0.7);
          }
        }
      }

      .action-buttons {
        display: flex;
        gap: 1rem;
        padding-top: 32px;

        .btn {
          width: 100%;
          padding: 10px 16px;
          border-radius: 8px;
          border: 1px solid #d5d7da;
          background: #fff;
          font-size: 16px;
          font-family: "Geist", sans-serif;
          font-weight: 500;
          cursor: pointer;
        }

        .cancel {
          color: rgba(10, 13, 18, 0.7);
        }

        .next {
          background: #2258f1;
          color: #fff;
          border: none;
          transition: all 0.3s ease;

          &:disabled {
            background: #f5f5f5 !important;
            border: 2px solid #e9eaeb !important;
            color: #a4a7ae !important;
            cursor: not-allowed;
          }
        }
      }
    }

    @media (max-width: 768px) {
      .modal-body {
        .broker-grid {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }
`;

export const SelectedBrokerConfirmationContainer = styled(Modal)`
  .modal-dialog {
    max-width: 384px;
  }

  .modal-content {
    padding: 0;
    border: none;
    border-radius: 16px;
  }

  .modal-body {
    padding: 1.5rem;
    margin-top: 24px !important;

    .broker-info {
      .broker-logo {
        width: 48px;
        height: 48px;
        border-radius: 50%;
      }

      .heading {
        font-size: 16px;
        font-weight: 500;
        margin: 16px 0 20px;
        font-family: "Geist", sans-serif;
        color: #181d27;

        .underline-text {
          text-decoration: underline;
        }
      }

      .info-section {
        margin-bottom: 2rem;
        padding-left: 0rem;

        .section-title {
          display: block;
          font-size: 14px;
          font-family: "Geist", sans-serif;
          font-weight: 500;
          color: rgba(10, 13, 18, 0.7);
        }

        .info-item {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          margin-top: 12px;

          .info-text {
            font-size: 12px;
            font-weight: 400;
            font-family: "Geist", sans-serif;
            line-height: 18px;
            color: rgba(65, 70, 81, 1);
          }
        }
      }
    }

    .btn-confirm {
      width: 100%;
      display: block;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5px;
    }
  }
`;

export const SuccessContainer = styled(Modal)`
  .modal-dialog {
    max-width: 657px;
  }

  .modal-content {
    position: relative;
    padding: 0;
    border: none;
    border-radius: 16px;

    .connection-success {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
  }

  .modal-body {
    padding: 1.5rem 1.5rem 1.5rem;
    margin-top: 0px !important;

    h2 {
      font-size: 24px;
      font-family: "Geist", sans-serif;
      font-weight: 600;
      text-align: center;
      padding-top: 132px;

      /* ✅ Gradient text color */
      background: linear-gradient(
        63deg,
        var(--colors-gray-light-mode-800, #252b37) 16.72%,
        var(--colors-gray-light-mode-600, #535862) 83.39%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }

    p {
      font-size: 16px;
      font-family: "Geist", sans-serif;
      font-weight: 400;
      line-height: 24px;
      color: rgba(10, 13, 18, 0.6);
      text-align: center;
      margin-bottom: 32px;

      .broker-logo {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
    }

    .btn-view-portfolio {
      width: 200px;
      margin: 0 auto;
    }

    .btn-back-dashboard {
      width: 200px;
      display: block;
      font-size: 16px;
      font-family: "Geist", sans-serif;
      font-weight: 500;
      color: rgba(10, 13, 18, 0.6);
      padding: 8px 0;
      margin: 12px auto 88px;
      border: none;
      background: none;
    }
  }
`;

export const ButtonStyleContainer = styled.div`
  .btn {
    display: block;
    padding: 8px 0;
    border-radius: 8px;
    font-size: 16px;
    font-family: "Geist", sans-serif;
    font-weight: 500;
    color: #fff;
    background: #2258f1;
    border: 2px solid transparent;
    background-image: linear-gradient(#2258f1, #2258f1),
      linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.12) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    background-origin: border-box;
    background-clip: padding-box, border-box;
  }

  .applyButton {
    width: 70px;
  }

  .next-button {
    font-size: 12px;
    padding: 6px 22px;
  }
`;
